import { Component, OnInit } from '@angular/core';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgEventsService } from '../bpg-events.service';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

@Component({
  selector: 'app-event-report',
  templateUrl: './event-report.component.html',
  styleUrls: ['./event-report.component.css']
})
export class EventReportComponent implements OnInit {

  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  adminId: any = localStorage.getItem('adminId');
  selectedEventsDetails: any = JSON.parse(sessionStorage.getItem('eventDetails'));
  reportDropdownList:any;
  landingDtoPage:any;
  landingDtoPageExport:any;
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage; 
  tableShow: boolean;
  eventReportData = [];  
  eventReportData1 = []; 
  noDataFound: boolean;
  currentPage = 0;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  numberOfElements: number;
  buttonType: any;
  reportTypeName: string = null;

  constructor(private readonly environment : EnvironmentConfiguration,
    
    private readonly router : Router,
    private readonly spinner : Ng4LoadingSpinnerService,
    private readonly bpgEventsService : BpgEventsService
    ) { }

  ngOnInit() {

    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
        this.router.navigate(['/log-out']);
        }

  }
  this.spinner.show();

  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });

  if(this.selectedEventsDetails.eventStatus==="SCHEDULED" || this.selectedEventsDetails.eventStatus==="CANCELLED"){
    this.reportDropdownList = [{ reportTypeName: "Registered" }]
  }else {
    this.reportDropdownList = [{ reportTypeName: "Attendance" },{ reportTypeName: "Registered" }]
  }

  setTimeout(function(){
    this.spinner.hide();
  }.bind(this), 1000)
}

  //to filter table list based on the report type
  changeDropDown(event) {
    this.tableShow = false;
    if (event.reportTypeName==="Attendance") {
      this.landingDtoPage = {
        "filter": { "eventId": this.selectedEventsDetails.eventId,
                    "chapterId": this.selectedEventsDetails.chapterId,
                    "reportType": "ATTENDANCE"  },
        "moduleId": 0,
        "page": 0,
        "presentRole": "",
        "searchTerm": "",
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "user_first_name",
        "uid": ""      
      }

      this.landingDtoPageExport = {
        "filter": { "eventId": this.selectedEventsDetails.eventId,
                    "chapterId": this.selectedEventsDetails.chapterId,
                    "reportType": "ATTENDANCE"  },
        "moduleId": 0,
        "page": 0,
        "presentRole": "",
        "searchTerm": "",
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "user_first_name",
        "uid": ""      
      }
    }
    else if (event.reportTypeName==="Registered") {   
      this.landingDtoPage = {
        "filter": { "eventId": this.selectedEventsDetails.eventId,
                    "chapterId": this.selectedEventsDetails.chapterId,
                    "reportType": "REGISTERED"  },
        "moduleId": 0,
        "page": 0,
        "presentRole": "",
        "searchTerm": "",
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "user_first_name",
        "uid": ""      
      }

      this.landingDtoPageExport = {
        "filter": { "eventId": this.selectedEventsDetails.eventId,
                    "chapterId": this.selectedEventsDetails.chapterId,
                    "reportType": "REGISTERED"  },
        "moduleId": 0,
        "page": 0,
        "presentRole": "",
        "searchTerm": "",
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "user_first_name",
        "uid": ""      
      }
    }
    this.tableShow = false;
    this.eventReportData = [];
    this.currentPage = 1;
  }

  generateReportClick(){
    this.spinner.show();

    this.listMembersDetails();
    setTimeout(function(){
      this.spinner.hide();
    }.bind(this), 1000)
    
    this.resetPageSizeForExport();
  }


  /** For getting the members details who attended or registered for event
  * @method listMembersDetails
  */
 listMembersDetails() {
  this.bpgEventsService.listEventReport(this.landingDtoPage).subscribe(data => {
    this.eventReportData = data.content;
    this.numberOfElements = data.totalElements;
    if(this.eventReportData.length>0){
      this.noDataFound = false;
      this.tableShow = true;      
    }else{
      this.tableShow = false;
      this.noDataFound = true;
    }
  }, err => {
    this.spinner.hide();
    if(err.value.statusText === ConstantValues.unknownError){
                this.timeOutError = true;
              }
  });
 }

  /** For service call to convert json to csv and save file 
  * @method exportAsCSV
  */
    exportAsCSV():void {     
      if(this.landingDtoPage.filter.reportType==="ATTENDANCE"){
        this.bpgEventsService.exportAsExcelFile(this.eventReportData1, "Attendance_"+this.selectedEventsDetails.eventName);
      }else {
       this.bpgEventsService.exportAsExcelFile(this.eventReportData1, "Registered_"+this.selectedEventsDetails.eventName);
      }
    }

    /** for resetting page size for exporting complete data into csv**/
    resetPageSizeForExport(){
      this.landingDtoPageExport.page = 0;
      this.landingDtoPageExport.size = 10000;
      this.bpgEventsService.listEventReport(this.landingDtoPageExport).subscribe(data => {

        if(this.landingDtoPageExport.filter.reportType==="ATTENDANCE"){ 
          this.eventReportData1 = data.content;
          const filterJSON = this.eventReportData1;
          for(const filter of filterJSON){
            delete filter.confirmed;
          }
          this.eventReportData1 = filterJSON;

        }else {
          this.eventReportData1 = data.content;
          const filterJSON = this.eventReportData1;
          for(const filter of filterJSON){
            delete filter.registered;
          }
          this.eventReportData1 = filterJSON;
        }       
      });
    }

      /** For filtering data by current page 
   * @class EventReportComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.landingDtoPage.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.listMembersDetails();
  }

   /** For goback from event view details to event list view 
   * @class EventReportComponent
   * @method goBack
   */
  goBack() {    
     sessionStorage.setItem(this.buttonType, "BACK");
     this.router.navigate(['events']);
     window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

}

